export default "__VITE_ASSET__Cyu5341M__"